import React from "react"
import Image, { StaticImageData } from "next/image"

type IllustrationProps = {
  src: string | StaticImageData
  alt: string
  className?: string
  width: number
  height: number
}

const Illustration = ({ src, alt, className, width, height }: IllustrationProps) => {
  return <Image src={src} alt={alt} width={width} height={height} className={className} />
}

export default Illustration
